import { SnLonLatBounds } from '@lib/geo/helpers';

import { toGoogleMapLatLng, fromGoogleMapLatLng } from './google-map-lat-lng';

export function toGoogleMapLatLngBounds(lonLatBounds: SnLonLatBounds): google.maps.LatLngBounds {
  const sw = toGoogleMapLatLng(lonLatBounds.getSouthWest());
  const ne = toGoogleMapLatLng(lonLatBounds.getNorthWest());

  return new google.maps.LatLngBounds(sw, ne);
}

export function fromGoogleMapLatLngBounds(latLngBounds: google.maps.LatLngBounds): SnLonLatBounds {
  const sw = fromGoogleMapLatLng(latLngBounds?.getSouthWest());
  const ne = fromGoogleMapLatLng(latLngBounds?.getNorthEast());

  return new SnLonLatBounds(sw, ne);
}
